<!-- Since Attachments code was copied from IT Spar some iteration may be needed,
specifically around setting editFormMode which controls the visibility of certain elements -->
<div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
  <span class="projectScopeHeader">Attachments</span>
</div>
<input
  [class.hiddenElement]="!editFormMode"
  type="file"
  style="display: none"
  (change)="onFileSelected($event)"
  #fileUpload
  multiple
/>
<div
  [class.hiddenElement]="!editFormMode"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  style="width: 49.125rem; height: 4.063rem; border: 0.063rem solid #ccc; border-radius: 0.875rem"
>
  <div style="text-align: center; margin-top: 1.125rem">
    <img style="width: 1rem; height: 1rem; padding-left: 1rem" src="assets/attach-file.svg" />
    <span style="color: rgb(105, 105, 105)">Drop a file here or </span>
    <span style="cursor: pointer" (click)="fileUpload.click()">browse to upload</span>
  </div>
</div>
@if (!editFormMode && files.length > 0) {
  <div style="width: 48.375rem; display: inline-block; padding-bottom: 1rem">
    <div style="margin-top: 1.5rem">
      <div style="display: inline-block">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">File Name</span>
      </div>
      <div style="display: inline-block; margin-left: 15rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Added By</span>
      </div>
      <div style="display: inline-block; margin-left: 10rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Date</span>
      </div>
      <div
        style="
          display: inline-block;
          height: 0.1rem;
          background-color: #f5f5f5;
          margin-bottom: 0.5rem;
          width: 46rem;
        "
      ></div>
      @for (file of files; track file; let i = $index) {
        <div>
          <div style="display: inline-block; width: 19.05rem">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
              file.fileName
            }}</span>
          </div>
          <div style="display: inline-block; width: 13.95rem">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
              file.addedByName
            }}</span>
          </div>
          <div style="display: inline-block">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{ file.date }}</span>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
            <img
              style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
              src="assets/file-download.svg"
              (click)="onDownloadFile(i)"
            />
          </div>
        </div>
      }
    </div>
  </div>
}
@if (editFormMode && filesCopy.length > 0) {
  <div
    style="
      background-color: #f3fafd;
      padding-top: 1.5rem;
      width: 48.375rem;
      margin-top: 1.5rem;
      display: inline-block;
      padding-bottom: 1rem;
    "
  >
    <div style="margin-top: 1.5rem; margin-left: 1.5rem">
      <div style="display: inline-block">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">File Name</span>
      </div>
      <div style="display: inline-block; margin-left: 15rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Added By</span>
      </div>
      <div style="display: inline-block; margin-left: 10rem">
        <span class="projectScopeSubHeader" style="font-size: 0.875rem">Date</span>
      </div>
      <div
        style="
          display: inline-block;
          height: 0.1rem;
          background-color: #f5f5f5;
          margin-bottom: 0.5rem;
          width: 46rem;
        "
      ></div>
      @for (file of filesCopy; track file; let i = $index) {
        <div>
          <div style="display: inline-block; width: 19.05rem">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
              file.fileName
            }}</span>
          </div>
          <div style="display: inline-block; width: 13.95rem">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
              file.addedByName
            }}</span>
          </div>
          <div style="display: inline-block">
            <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{ file.date }}</span>
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
            <img
              style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
              src="assets/file-download.svg"
              (click)="onDownloadFile(i)"
            />
          </div>
          <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
            <img
              style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
              src="assets/trash-bin-base.svg"
              (click)="onDeleteFile(i)"
            />
          </div>
        </div>
      }
    </div>
  </div>
}
<div style="margin-top: 0.5rem; margin-bottom: 0.5rem">
  <span class="projectScopeNonHeader">
    Note: Files are for review purposes only. Files uploaded in MMAPS will
    <span style="font-style: italic; font-size: 0.9rem">not</span> be added to PowerPlan.
  </span>
</div>
